import createCachedSelector from 're-reselect'
import { isDefined } from 'util/nullOrUndefinedChecks'
import { byProductCacheKey } from './byProductCacheKey'
import { selectBillingUsageForProduct } from './selectBillingUsageForProduct'
import { selectLocalUsageForProduct } from './selectLocalUsageForProduct'

export const selectUsageForProduct = createCachedSelector(
  selectLocalUsageForProduct,
  selectBillingUsageForProduct,
  (localUsageForProduct, billingUsageForProduct) => {
    const usage = {}
    Object.keys(billingUsageForProduct).forEach(key => {
      usage[key] = isDefined(localUsageForProduct[key])
        ? localUsageForProduct[key]
        : billingUsageForProduct[key]
    })
    return usage
  }
)(byProductCacheKey)
